<template>
  <component :is="template"></component>
</template>

<script>
  import {STORE_KEY} from './_store/constants'
  import {STORE_KEY as STORE_KEY_QUESTION} from '@/modules/question/preview-question/_store/constants'
  import store from './_store'
  import storeQuestion from '@/modules/question/preview-question/_store'
  import EBookList from './_components/EBookList'
  import EBookFilter from './_components/EBookFilter'
  import EBookDetail from './_components/EBookDetail'
  import EBookDetailRead from './_components/EBookDetailRead'
  import EBookDetailRead2 from './_components/EBookDetailRead2'
  import EBookType from './_components/EBookType'
  import EBookClasses from './_components/EBookClasses'
  import EBookReadBook from './_components/EBookReadBook'
  import EBookReadBook2 from './_components/EBookReadBook2'
  //import EBookGroup from './_components/EBookGroup'
  import BookGroup from './_components/BookGroup'


  export default {
    name: 'EBookModule',
    props: {
      template: String
    },
    components: {
      EBookList,
      EBookFilter,
      EBookDetail,
      EBookType,
      EBookClasses,
      EBookDetailRead,
      EBookDetailRead2,
      EBookReadBook,
      EBookReadBook2,
      //EBookGroup
      BookGroup
    },
    created () {
      if (!(STORE_KEY in this.$store._modules.root._children)) {
        this.$store.registerModule(STORE_KEY, store);
      }
      if (!(STORE_KEY_QUESTION in this.$store._modules.root._children)) {
        this.$store.registerModule(STORE_KEY_QUESTION, storeQuestion);
      }
    }
  }
</script>